(function () {
  var KEY_ID = 'pirate_design_id';
  var KEY_VARIANT = 'pirate_print_variant';
    var APP_URL = 'https://design.gopirateink.com';

  function save(id, variant) {
    try {
      sessionStorage.setItem(KEY_ID, id);
      sessionStorage.setItem(KEY_VARIANT, variant);
    } catch (e) {}
  }

  function getId() {
    try { return sessionStorage.getItem(KEY_ID); } catch (e) { return null; }
  }

  function getVariant() {
    try { return sessionStorage.getItem(KEY_VARIANT); } catch (e) { return null; }
  }

  function clear() {
    try {
      sessionStorage.removeItem(KEY_ID);
      sessionStorage.removeItem(KEY_VARIANT);
    } catch (e) {}
  }

  var params = new URLSearchParams(window.location.search);
  var urlId = params.get('design');
  var urlVariant = params.get('print');

  if (urlId && urlVariant) {
    save(urlId, urlVariant);
  }

  window.PirateDesign = {
    id: getId,
    variant: getVariant,
    clear: clear,
    appUrl: APP_URL,
    recoveryUrl: function () {
      var id = getId();
      return id ? APP_URL + '/design/' + id : APP_URL;
    }
  };

  function renderBanner() {
    var id = getId();
    if (!id) return;
    if (document.getElementById('pirate-design-banner')) return;

    var main = document.querySelector('main') || document.body;
    var bar = document.createElement('div');
    bar.id = 'pirate-design-banner';
    bar.style.cssText = 'background:#e8f7fd;border:1px solid #29ABE2;border-radius:8px;padding:12px 16px;margin:16px auto;max-width:1200px;font-size:14px;display:flex;align-items:center;justify-content:space-between;gap:12px;flex-wrap:wrap;';
    bar.innerHTML =
      '<span>Your design is attached — pick a shirt below and it will be added to your order.</span>' +
      '<a href="' + window.PirateDesign.recoveryUrl() + '" style="color:#29ABE2;text-decoration:underline;white-space:nowrap;">View my design</a>';

    main.insertBefore(bar, main.firstChild);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderBanner);
  } else {
    renderBanner();
  }
})();